import React from 'react'

interface PageNavigationProps {
  currentPage: number
  numPages: number
  onPageChange: (page: number) => void
}

export const PageNavigation: React.FC<PageNavigationProps> = ({
  currentPage,
  numPages,
  onPageChange
}) => {
  if (numPages <= 1) {
    return null
  }

  return (
    <div className="absolute top-[5px] left-1/2 transform -translate-x-1/2 bg-white rounded shadow-md px-3 py-1.5 flex items-center gap-2 z-20">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage <= 1}
        className="p-1 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed"
        title="Previous page"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-medium text-gray-600">Page</span>
        <input
          type="number"
          value={currentPage}
          onChange={(e) => {
            const page = parseInt(e.target.value, 10)
            if (page >= 1 && page <= numPages) {
              onPageChange(page)
            }
          }}
          className="w-12 px-1.5 py-0.5 text-xs border border-gray-300 rounded text-center font-medium"
          min={1}
          max={numPages}
        />
        <span className="text-xs text-gray-500">of {numPages}</span>
      </div>
      
      <button
        onClick={() => onPageChange(Math.min(numPages, currentPage + 1))}
        disabled={currentPage >= numPages}
        className="p-1 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed"
        title="Next page"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  )
}

